<mat-form-field class="input-container" appearance="outline">
    <mat-label>{{ labelKey | translate }}</mat-label>
    @if (type() === 'textarea') {
        <textarea matInput [type]="type()" [value]="value" [placeholder]="labelKey | translate" (input)="onInputChange($event)" [disabled]="isDisabled()" [required]="_isRequired()"></textarea>
    } @else {
        <input matInput [type]="type()" [value]="value" [min]="min()" [max]="max()" [placeholder]="labelKey | translate" (input)="onInputChange($event)" [disabled]="isDisabled()" [required]="_isRequired()">
    }
</mat-form-field>
@if (showError()) {
    @for (msg of errorMessages(); track msg) {
        <mat-error>{{ msg }}</mat-error>
    }
}
